import ClearIcon from '@mui/icons-material/Clear';
import * as React from 'react';

interface Props {
  children: React.ReactNode;
  onClose: () => void;
}

/** Convenience component to avoid having to restyle our header for each modal */
export const ModalHeader: React.FC<Props> = (props) => {
  return (
    <div className="px-8 py-4 flex justify-between items-center">
      {props.children}
      <ClearIcon onClick={props.onClose} className="cursor-pointer h-5" />
    </div>
  );
};
ModalHeader.displayName = 'ModalHeader';
